import { useCallback } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { WhiteStyledField } from 'libs/form';

export const DatePeriod = (props) => {
  const { reqFrom = false, reqTo = false } = props;
  const { t } = useTranslation();
  const fn1 = 'start_at';
  const fn2 = 'end_at';

  const validateFrom = (value, values) => {
    // console.log('from value', value, values);
    if (reqFrom && !value) {
      return t('validation.Обязательное поле');
    }
    if ((!reqFrom && !value) || !values[fn2]) {
      return undefined;
    }
    const d1 = moment(value);
    const d2 = moment(values[fn2]);
    if (d1 > d2) {
      return t('validation.Дата и время с не может быть позднее Даты и времени по');
    }
    return undefined;
  };

  const validateTo = (value, values) => {
    // console.log('to value', value, values);
    if (reqTo && !value) {
      return t('validation.Обязательное поле');
    }
    if ((!reqTo && !value) || !values[fn1]) {
      return undefined;
    }
    const d1 = moment(value);
    const d2 = moment(values[fn1]);
    if (d1 < d2) {
      return t('validation.Дата и время по не может быть ранее Даты и времени с');
    }
    return undefined;
  };

  const validateFromT = useCallback(validateFrom, []);
  const validateToT = useCallback(validateTo, []);

  const title1 = t('form.Дата действия с');
  const title2 = t('form.Дата действия по');

  return (
    <>
      <WhiteStyledField className="shortfield" type="dateTime" label={title1} placeholder={title1} name={fn1} validate={validateFromT} />
      <WhiteStyledField className="shortfield" type="dateTime" label={title2} placeholder={title2} name={fn2} validate={validateToT} />
    </>
  );
};
